<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:platformName="{ row }">
        <div class="m-0">
          <TableLabel :label="''" :value="row.platformName" />
          <TableLabel :label="''" :value="row.custName" />
        </div>
      </template>
      <template v-slot:inContainerQty="{ row }">
        <div class="m-0">
          <span> {{ row.inContainerQty }}</span>
          <span> {{ row.v_inContainerUnit }}</span>
        </div>
      </template>
      <template v-slot:palletItemNo="{ row }">
        <div class="m-0">
          <TableLabel :label="'ITEM'" :value="row.palletItemNo" />
          <TableLabel :label="''" :value="row.palletItemName" />
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
}
</script>
